import styled from 'styled-components'

const IconPickerContentUi = styled.div`
  padding: 10px;
  display: flex;
`

export default IconPickerContentUi
